<template>
  <detail-page-layout :config="pageConfig">
    <el-table v-loading="IsLoading" element-loading-text="加载中" :data="[service]">
      <el-table-column label="下单时间" width="170">
        <template scope="props">
          {{props.row.CreateOn | date('YYYY-MM-DD HH:mm')}}
        </template>
      </el-table-column>
      <el-table-column label="委托订单" width="200">
        <template scope="props">
          {{props.row.Code}}
        </template>
      </el-table-column>
      <el-table-column label="总数量"  width="80">
        <template scope="props">
          {{props.row.TotalQuantity}}
        </template>
      </el-table-column>
      <el-table-column label="客户总报价"  width="110">
        <template scope="props">
          {{props.row.TotalPrice}}
        </template>
      </el-table-column>
      <el-table-column label="委托类型"  width="100">
        <template scope="props">
          {{props.row.Type | EntrustType}}
        </template>
      </el-table-column>
      <el-table-column label="委托时长" width="100">
        <template scope="props">
          {{props.row.EntrustDay}}天
        </template>
      </el-table-column>
      <el-table-column label="区域">
        <template scope="props">
          {{props.row.RegionName}}
        </template>
      </el-table-column>
    </el-table>
    <h3 style="line-height: 3em;">物料清单</h3>
    <el-table v-loading="IsLoading" element-loading-text="加载中" :data="servicelist">
      <el-table-column type="expand">
        <template scope="props">
          <table class="batch_table">
            <tbody>
              <tr v-for="item in props.row.Batchs">
                <td>
                  批次号：
                  <p>{{item.BatchCode}}</p>
                </td>
                <td v-if="item.Type === 2">
                  数量：
                  <p>{{item.Quantity}}</p>
                </td>
                <td>
                  原始品项：
                  <el-tag :type="item.ItemQualityName | ConditionColor">{{item.ItemQualityName}}</el-tag>                  
                </td>
                <td>
                  入库品项：
                  <el-tag :type="item.StockItemQualityName | ConditionColor">{{item.StockItemQualityName}}</el-tag>
                </td>
                <td>
                  质检报告：
                  <p>{{item.QualityRemark}}</p>
                </td>
                <td>
                  分成比例：
                  <p>{{item.Scale | Scale}}</p>
                </td>
                <td v-if="pageConfig.Step === 3">
                  检测报价：
                  <p>{{item.ConfirmPrice}}</p>
                </td>
                <td>
                  处理结果：
                  <p v-if="item.StockQuantity > 0">入库数：{{item.StockQuantity}}</p>
                  <p v-if="item.ReturnQuantity > 0">退回数：{{item.ReturnQuantity}}</p>
                  <p v-if="item.RepairQuantity > 0">维修数：{{item.RepairQuantity}}</p>
                </td>
                <td>
                  维修记录：
                  <p v-if="item.RepairQuantity > 0">有</p>
                  <p v-else>无</p>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </el-table-column>
      <el-table-column label="物料名称／编码" width="260">
        <template scope="props">
          <el-col>{{props.row.ItemName}}</el-col>
          <el-col>物料编码：{{props.row.ItemCode}}</el-col>
        </template>
      </el-table-column>
      <el-table-column label="客户物料名称／编码" width="260">
        <template scope="props">
          <el-col>{{props.row.CustomerItemName}}</el-col>
          <el-col>物料编码：{{props.row.CustomerItemCode}}</el-col>
        </template>
      </el-table-column>
      <el-table-column label="品牌">
        <template scope="props">
          {{props.row.BrandName}}
        </template>
      </el-table-column>
      <el-table-column label="机型" width="140">
        <template scope="props">
          {{props.row.MachineName}}
        </template>
      </el-table-column>
      <el-table-column label="模块" width="120">
        <template scope="props">
          {{props.row.ModuleName}}
        </template>
      </el-table-column>
      <el-table-column label="数量">
        <template scope="props">
          {{props.row.Quantity}}
        </template>
      </el-table-column>
      <!-- <el-table-column label="委托时长" width="100">
        <template scope="props">
          {{props.row.RentTime}}天
        </template>
      </el-table-column> -->
      <el-table-column label="报价">
        <template scope="props">
          {{props.row.Price}}
        </template>
      </el-table-column>
    </el-table>
  </detail-page-layout>
</template>

<script>
import DetailPageLayout from '@/components/common/DetailPageLayout'
import o from '@/odata'
export default {
  mounted() {
    this.initServices()
  },
  data() {
    return {
      IsLoading: false,
      repairReasonFormVisible: false,
      resultFormVisible: false,
      repairReason: '',
      pageConfig: {
        StepsBarEnabled: true,
        Steps: [
          { key: 'receiving', title: '受托方待收货' },
          { key: 'qc', title: '受托方处理中' },
          { key: 'review', title: '已完成' },
        ],
        Step: 1,
        Breadcrumbs: [
          {
            to: { name: 'EntrustList' },
            name: '委托订单列表',
          },
          {
            name: '委托订单',
          },
        ],
      },
      service: {},
      servicelist: [],
      qcLines: {
        Lot: {},
        Product: {},
        Condition: {},
      },
      qcdetail: [],
      // listURL: 'http://api.atm020.com/api/services/app/delegationService/AllEntrust',
      // detailURL: 'http://api.atm020.com/api/services/app/delegationService/EntrustByCode',
      objURL: process.env.API_HOST + '/services/app/delegationService/EntrustByCode',
    }
  },
  methods: {
    initServices: function() {
      this.IsLoading = true
      let URL = this.objURL + '?entrustCode=' + this.$route.params.id
      this.$http.get(URL).then((response) => {
        this.IsLoading = false
        // 委托单信息
        this.service = response.data
        if (this.service.State === 1) {
          this.pageConfig.Step = 1
        } else if (this.service.State === 2) {
          this.pageConfig.Step = 2
        } else if (this.service.State === 3) {
          this.pageConfig.Step = 3
        }
        // 物料清单
        this.servicelist = this.service.EntrustDetails
        console.log('物料清单', this.servicelist)
        // 初始化物料批次维修单号为'无'
        // this.servicelist[0].Batchs.forEach(function(item) {
        //   item.RepairOrderCode = '无'
        // })
        // this.initRepairCode()
      }).catch((response) => {
        this.IsLoading = false
      })
    },
    // 初始化批次维修订单
    initRepairCode: function() {
      const Services = o('RepairOrder').expand('Lines($expand=Lot)')
      Services.orderBy('OrderDate', 'asc')
      // 获取所有维修订单
      Services.get().then((data) => {
        // 遍历每个维修订单
        data.data.forEach(function(item) {
          // 遍历维修订单中的明细
          item.Lines.forEach(function(item2) {
            // 遍历委托订单的所有物料批次
            this.servicelist[0].Batchs.forEach(function(item3) {
              console.log(`${item3.BatchCode}===${item2.Lot.Code}`)
              // 比较是否该批次包含在维修订单中，存在则赋值给这个批次的RepairOrderCode
              if (item3.BatchCode === item2.Lot.Code) {
                item3.RepairOrderCode = item.Code
              }
            })
          }, this)
        }, this)
      })
    },
    // initServices: function() {
    //   let URL = this.listURL + '?entrustCode=' + this.$route.params.id
    //   this.$http.get(URL).then((response) => {
    //     this.service = response.data.items[0]
    //     if (this.service.State === 1) {
    //       this.pageConfig.Step = 1
    //     } else if (this.service.State === 2) {
    //       this.pageConfig.Step = 2
    //     } else if (this.service.State === 3) {
    //       this.pageConfig.Step = 3
    //     }
    //     console.log(this.Step)
    //     this.initDetail()
    //   }).catch((response) => { })
    // },
    // initDetail: function() {
    //   let loading = Loading.service({ text: '加载中' })
    //   let URL = this.detailURL + '?&entrustCode=' + this.service.Code
    //   console.log(URL)
    //   this.$http.get(URL).then((response) => {
    //     this.servicelist = response.data
    //     loading.close()
    //   }).catch((response) => { })
    // },
  },
  components: {
    DetailPageLayout,
  },
}
</script>

<style lang="less" scoped>
.batch_table {

  td {
    padding: 15px;
    font-size: 12px;
    color: #86939E;
    background-color: #fbfdff;
    p {
      display: block;
      margin-top: 6px;
      color: #001E00;
    }
  }
  .el-table td:last-child {
    border-bottom: none;
  }
}

.red {
  color: #FF4949;
}

.demo-table-expand {
  .el-form-item {
    width: 24%;
    margin-bottom: 0;
    margin-right: 0;
    span {
      font-size: 14px;
      color: #1F2D3D;
    }
    .span-blue {
      color: #20A0FF;
    }
  }
}

h3 {
  color: 354052;
  font-size: 24px;
  span {
    font-size: 20px;
    color: #A6AFB7;
    font-weight: normal;
  }
}

.pop-box .el-dialog--large {
  width: 80%;
}

.el-table__expanded-cell {
  background: #F5F7FA;
  box-shadow: inset 0 0 0 0 #E0E6ED, inset 0 0 0 1px #E0E6ED;
}

.el-dialog__body .el-form {
  padding-bottom: 20px;
}

.pop-box p.pull-left {
  font-size: 14px;
  color: #7F8FA4;
}

.list-box {
  h4 {
    margin-bottom: 25px;
    .el-button {
      margin-top: -5px;
      margin-right: 15px;
    }
  }
}

.chose-box {
  margin-bottom: 20px;
  .chose-item {
    margin-right: 20px;
    display: inline-block;
    p {
      margin-bottom: 5px;
      font-size: 14px;
      color: #7F8FA4;
    }
  }
}

.replacement {
  background: #FEFEFE;
  border: 1px solid #BCCCDA;
  border-radius: 4px;
  padding: 15px 20px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #7F8FA4;
}

.replacement span {
  color: #354052;
  margin-left: 20px;
}

.review-table {
  padding-bottom: 30px;
  border-bottom: 1px solid #E0E6ED;
  h5 {
    font-size: 18px;
    color: #7F8FA4;
    margin: 0 0 10px;
  }

  td {
    padding: 15px;
  }
  table thead td {
    background: #E5E9F2;
    box-shadow: inset 0 1px 0 0 #E0E6ED, inset 1px 0 0 0 #E0E6ED, inset 0 -1px 0 0 #E0E6ED;
  }
  tbody {
    background: #FFFFFF;
    box-shadow: inset 0 0 0 0 #E0E6ED, inset 0 0 0 1px #E0E6ED;
  }
}

.pop-box.review-table {
  table {
    margin-bottom: 30px;
  }
  table tbody td {
    border-bottom: 1px solid #E0E6ED;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
}
</style>



// WEBPACK FOOTER //
// EntrustDetailPage.vue?7ac4eb16